import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  GridItem,
  SimpleGrid
} from "@chakra-ui/react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { bconf, ProductProps, TypeCategory, SortByOption } from "../../app/index";
import {
  useAppConfig,
  useFetchProducts,
  useFiltersBanner,
  useValidateSession,
} from "../../hooks/index";
import { LoadingSpinner } from "../loadingSpinner/loadingSpinner";
import { DisplayError } from "./error";
import { Paginator } from "./paginator";
import ProductElement from "./product";
import { FiltersBanner } from "./searchBar/filtersBanner";
import { SortControls } from "./searchBar/sortControls";

const CatalogContent = () => {
  const { user } = useValidateSession(null);
  const { ctaColor, ctaTextColor } = useAppConfig();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    result: { isLoading, isError, data, isSuccess, error },
    currentPage,
    setCurrentPage,
    querySearch,
    setquerySearch,
  } = useFetchProducts(user.t);

  const { filterBtnRef, filterIsOpen, filterOnClose, filterOnOpen } =
    useFiltersBanner();

  const [isOpen, setIsOpen] = useState(true);
  //const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);

  const doSearch = (
    selectedCat: TypeCategory[],
    selectedKeywords: string,
    rangeValues: number[]
  ): void => {
    filterOnClose();
    setSearchParams({
      filters: "true",
      pmin: rangeValues[0].toString(),
      pmax: rangeValues[1].toString(),
      keywords: selectedKeywords,
      category: selectedCat
        .map((element) => {
          return element.key.toString();
        })
        .join(","),
      sortby: querySearch.sortby || 'brand_crescente',
    });

    setCurrentPage(1);
  };

  const handleSortChange = (sort: SortByOption): void => {
    setquerySearch({
      ...querySearch,
      sortby: sort,
    });
    const newParams = new URLSearchParams(searchParams);
    newParams.set('sortby', sort);
    setSearchParams(newParams);
    setCurrentPage(1);
  };

  return (
    <Box
      className="catalog"
      id="grid-result"
      p="1em"
      w={"100%"}
      fontSize={["sm", "md"]}
      marginTop="0px"
    >
      <>
        <Flex
          pt={2}
          pb={2}
          as="header"
          position="sticky"
          w="100%"
          backgroundColor="rgba(255, 
 255, 255, 0.8)"
          backdropFilter="saturate(180%) blur(5px)"
          zIndex="200"
          top="0"
        >
          <Flex w="100%" align="center" justify="space-between" gap={4}>
            <Flex align="center" gap={2}>
              <Button
                rightIcon={<ChevronDownIcon />}
                ref={filterBtnRef}
                onClick={filterOnOpen}
                bgColor={ctaColor}
                color={ctaTextColor}
                _hover={{ bg: ctaColor }}
                _active={{
                  bg: ctaColor,
                  transform: "scale(0.98)",
                  borderColor: ctaColor,
                }}
              >
                Filtri
              </Button>

              <FiltersBanner
                isOpen={filterIsOpen}
                onClose={filterOnClose}
                btnRef={filterBtnRef}
                callbackSearch={doSearch}
                querySearch={querySearch}
                excludeCategories={""}
              />

              <SortControls
                currentSort={querySearch.sortby || 'brand_crescente'}
                onSortChange={handleSortChange}
              />
            </Flex>

            {isSuccess && (
              <Box ml="auto">
                <Paginator
                  currentPage={currentPage}
                  totalPages={
                    data?.data
                      ? Math.ceil(data.data.total / bconf().totalProductPerPage)
                      : 0
                  }
                  setCurrentPage={setCurrentPage}
                />
              </Box>
            )}
          </Flex>
        </Flex>
        {isError && error && error instanceof Error && (
          <DisplayError error={error} />
        )}
        {isLoading && <LoadingSpinner isLoading={isLoading} />}
        <Center p={5} as="main">
          <SimpleGrid columns={[1, 2, 2, 3, 4]} spacing={5}>
            {isSuccess &&
              data &&
              data.data.results.map((element: ProductProps) => {
                return (
                  <ProductElement
                    {...element}
                    key={element.id}
                    baseURL={user.t?.ImageBaseURL}
                  />
                );
              })}
          </SimpleGrid>
        </Center>
        {isSuccess && (
          <Paginator
            currentPage={currentPage}
            totalPages={
              data?.data
                ? Math.ceil(data.data.total / bconf().totalProductPerPage)
                : 0
            }
            setCurrentPage={setCurrentPage}
          />
        )}
      </>
    </Box>
  );
};

export default CatalogContent;
